import type { FormControlProps } from '@mui/material';
import { FormControl, styled } from '@mui/material';
import type { FC } from 'react';

interface CustomFormControlProps extends FormControlProps {
  whiteBackground?: boolean;
}

const StyledFormControl = styled(FormControl, {
  shouldForwardProp: prop => prop !== 'whiteBackground',
})<CustomFormControlProps>(({ theme, whiteBackground }) => ({
  outline: 'none',
  '& .MuiFilledInput-root': {
    borderRadius: 16,
    backgroundColor: whiteBackground
      ? theme.vars.palette.common.white
      : theme.vars.palette.grey[100],
    borderBottom: 'none !important',
    '&:before': {
      borderBottom: 'none !important',
    },
    '&:after': {
      borderBottom: 'none !important',
    },
  },
  '& .MuiInputLabel-root': {
    color: theme.vars.palette.text.secondary,
  },
}));

const CustomFormControl: FC<
  Omit<CustomFormControlProps, 'variant'>
> = props => <StyledFormControl {...props} variant="filled" />;

export default CustomFormControl;
